import {cDisplay} from '../creator/cDisplay'
import { cGame } from "../creator/cGame";
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class citySquereDisplay extends cDisplay {

  private code: string[] = ['0','0','0']
  private rnd_obj: any

  init(){
    super.init()
    this.rnd_obj = {}
    var cS:cScene = this.scene as cScene;
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
      }
    })
  }

  getRAND(){
    var found = false
    var val;
    var cc = 0
    while (!found){

      if (!val){
        val = Math.floor( Math.random() * 11);
      }else{
        val = (val + 1) % 11;
      }      
      if (!this.rnd_obj[val]){
        this.rnd_obj[val] = 1;
        found = true;
      }
      if (cc++ > 12) found=true
    }
    return val;
  }

  buildScene(){    
    var cS:cScene = this.scene as cScene;
    super.buildScene();

    //var pos = ['489x940','395x879','449x880','697x881','626x846','719x809','898x767','610x695','536x694','604x668','654x550','725x568','1184x605','1156x535','1206x531','1093x535','1135x498','1146x446','1103x411','980x468','1070x265','1158x298','1275x334','1454x421']
    var n:cContainer = this.getByName('peopleContainer')
    var pos:any[] = n.modules.data._extraData.pos
    var assetName = n.modules.data._extraData.asset
    var mpx = n.modules.data._extraData.mpx
    var min = n.modules.data._extraData.min

    var sf = Phaser.Utils.Array.Shuffle(pos).map((s:string)=>{
      return s.split('x').map(n=>Number(n))
    })


    for (var a=0;a < 6; a++){
      var [xx,yy,sc] = sf.pop()
      var sp = cS.add.sprite(Number(xx),Number(yy),assetName, 'person_'+this.getRAND()+'.png')
      var siz = (Number(yy)-298) / 642
      sp.scale = min + (mpx*siz);
      n.add(sp)
      console.log(yy,siz)
    }

    n.sort('y')
    

    var nn = this.getByName('item_11')

    if (cGame.debugmode && nn){
      setTimeout( ()=>{
        if (!cS.input) return
   
        nn.setInteractive({'useHandCursor':true, draggable: true });  
        cS.input.setDraggable( nn )
        cS.input.on('dragend',(p:any,gameObj:any)=>{
          pos.push( gameObj.x+'x'+gameObj.y)
          console.log( pos.join(','))
        });
    
        cS.input.on('drag',(p:any,gameObj:any,x:number,y:number)=>{
          gameObj.x = Math.round(x);
          gameObj.y = Math.round(y);
        });  
      },10)
    }



  }
}
